import React from "react";

const STEPS = [
  { n: "01", title: "Contact Us",         desc: "Call 403-404-3515 or book online — takes under a minute." },
  { n: "02", title: "Schedule Appointment", desc: "Pick the location and time that works best for you." },
  { n: "03", title: "We Come To You",     desc: "Home, work, or roadside — our mobile unit arrives on time." },
  { n: "04", title: "Drive Away Happy",   desc: "Fast, professional service without ever visiting a shop." },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="section-mv bg-white">
      <div className="container-mv">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold tracking-widest text-brand-red uppercase">How It Works</div>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-black">
            Four simple steps to <span className="text-brand-red">fresh tires.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-4 relative">
          {/* dashed connector */}
          <div className="hidden md:block absolute top-8 left-[12%] right-[12%] h-[2px] timeline-line" />
          {STEPS.map((s, idx) => (
            <div key={s.n} className="relative">
              <div className="relative z-10 w-16 h-16 rounded-full bg-white border-2 border-brand-red text-brand-red font-display font-extrabold text-lg flex items-center justify-center shadow-sm">
                {s.n}
              </div>
              <h3 className="mt-5 font-display font-bold text-xl text-brand-black">{s.title}</h3>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed max-w-xs">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
